import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router'
import css from './Tile.module.css'

export default function Tile (props) {
  const { image, title, subtitle, href, tag, onClick } = props

  return (
    <OptionalLink href={href} onClick={onClick}>
      <div className={css.image}>
        <img src={image} alt='' />
      </div>
      <div className={css.title}>{title}</div>
      {subtitle && <div className={css.subtitle}>{subtitle}</div>}
      {tag && <div className={css.tag}>{tag}</div>}
    </OptionalLink>
  )
}

function OptionalLink ({ href, children, onClick }) {
  return (
    href
    ? <Link className={css.main} to={href} onClick={onClick}>{children}</Link>
    : <div className={css.main}>{children}</div>
  )
}

Tile.displayName = 'Tile'

Tile.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  href: PropTypes.string,
  tag: PropTypes.string,
  onClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./components/Catalog/Tile.js